import React from "react";
import { useT } from "@/i18n";

const CODES = ["SS 100", "—", "EX 200", "PR 300", "CS 400", "HG 500"];
const PRIMARY_IDX = 1;

const System = () => {
  const { t } = useT();
  return (
    <section id="system" data-testid="system-section" className="relative py-24 sm:py-32 bg-[#faf7f2]">
      <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-[#ea7a1f]/40 to-transparent" />

      <div className="max-w-7xl mx-auto px-6 sm:px-12">
        <div className="relative aspect-[21/8] sm:aspect-[21/6] overflow-hidden mb-16 group">
          <img
            src="/generated/commercial_entry.png"
            alt="Commercial entrance with exposed-aggregate concrete finish"
            className="w-full h-full object-cover transition-transform duration-[2000ms] group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-black/65 via-black/25 to-transparent" />
          <div className="absolute inset-0 flex items-center px-8 sm:px-16">
            <div className="max-w-xl text-white">
              <div className="overline !text-[#ff9d4d] mb-3">{t.system.banner.overline}</div>
              <h3 className="font-display text-3xl sm:text-5xl tracking-tight leading-[1.05] text-white">
                {t.system.banner.h}
              </h3>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 mb-16 items-end">
          <div className="md:col-span-7">
            <div className="overline mb-6">{t.system.overline}</div>
            <h2 className="font-display text-4xl sm:text-6xl tracking-tight leading-[1.02]">
              {t.system.h}<br />{t.system.h2}
            </h2>
          </div>
          <div className="md:col-span-5">
            <p className="text-zinc-600 leading-relaxed">{t.system.sub}</p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-black/10 border border-black/10">
          {t.system.items.map(([name, role], i) => {
            const primary = i === PRIMARY_IDX;
            return (
              <div
                key={i}
                data-testid={`system-item-${i}`}
                className={`relative p-8 sm:p-10 group transition-all duration-500 ${
                  primary
                    ? "bg-[#ea7a1f] text-white hover:bg-[#f08b34]"
                    : "bg-[#faf7f2] hover:bg-white"
                }`}
              >
                <div className="flex items-start justify-between mb-10">
                  <span className={`text-xs tracking-[0.3em] uppercase ${primary ? "text-white/80" : "text-zinc-500"}`}>
                    {CODES[i]}
                  </span>
                  <span className={`font-display num-display ${primary ? "text-white/50" : "text-zinc-300"}`}>
                    0{i + 1}
                  </span>
                </div>
                <h3 className={`font-display text-2xl sm:text-3xl mb-4 tracking-tight ${primary ? "text-white" : ""}`}>
                  {name}
                </h3>
                <p className={`leading-relaxed ${primary ? "text-white/85" : "text-zinc-600"}`}>{role}</p>
                {primary && (
                  <div className="mt-6 inline-flex items-center gap-2 text-xs tracking-[0.25em] uppercase font-bold text-white">
                    {t.system.flagship}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default System;
